/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Qc_Fix_Applied_ToastInputs */



/**
* | output |
* | --- |
* | "Automatic fixes applied ({count} changes)" |
*
* @param {Qc_Fix_Applied_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_applied_toast = /** @type {((inputs: Qc_Fix_Applied_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Applied_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Corrections automatiques appliquées (${i?.count} modifications)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Automatische Korrekturen angewendet (${i?.count} Änderungen)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Correzioni automatiche applicate (${i?.count} modifiche)`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Автоматические исправления применены (${i?.count} изменений)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Correcciones automáticas aplicadas (${i?.count} cambios)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已应用自动修复（${i?.count} 处更改）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`自動修正を適用しました（${i?.count}件の変更）`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्वचालित सुधार लागू किए गए (${i?.count} बदलाव)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Correções automáticas aplicadas (${i?.count} alterações)`)
	return /** @type {LocalizedString} */ (`Automatic fixes applied (${i?.count} changes)`)
});